var map = {
	"./Saudi_League.jpg": 19986,
	"./ajax.jpg": 16509,
	"./aldosivi.jpg": 2525,
	"./all-boys.jpg": 50533,
	"./allLPF.jpg": 42842,
	"./argentinos-juniors.jpg": 56423,
	"./arsenal-de-sarandi.jpg": 69486,
	"./arsenal.jpg": 42666,
	"./aston_villa.jpg": 99729,
	"./atalanta.jpg": 13108,
	"./atenas.jpg": 72563,
	"./atlante.jpg": 84958,
	"./atlas_guadalajara.jpg": 68199,
	"./atletico-rafaela.jpg": 40482,
	"./atletico-tucuman.jpg": 39154,
	"./atletico_madrid.jpg": 53668,
	"./atletico_morelia.jpg": 91226,
	"./atletico_san_luis.jpg": 79656,
	"./banfield.jpg": 14818,
	"./barcelona.jpg": 18866,
	"./barracas-central.jpg": 29029,
	"./bayern_munich.jpg": 49223,
	"./belgrano-de-cordoba.jpg": 90894,
	"./benfica.jpg": 62612,
	"./boca-juniors.jpg": 9661,
	"./bologna.jpg": 52740,
	"./borussia_dortmund.jpg": 60319,
	"./boston_river.jpg": 65751,
	"./bournemouth.jpg": 20352,
	"./brentford-fc.jpg": 27229,
	"./brighton_and_hove_albion.jpg": 66173,
	"./burnley-fc.jpg": 45477,
	"./ca_cerro.jpg": 81224,
	"./cardiff-city.jpg": 28412,
	"./celtic.jpg": 40162,
	"./central-cordoba-sde.jpg": 39603,
	"./cerrito.jpg": 10057,
	"./cerro_largo.jpg": 7052,
	"./cf_america.jpg": 27921,
	"./cf_monterrey.jpg": 86772,
	"./cf_pachuca.jpg": 39174,
	"./chacarita-juniors_2.jpg": 8000,
	"./chelsea.jpg": 34182,
	"./club_leon.jpg": 38984,
	"./club_necaxa.jpg": 76393,
	"./club_tijuana.jpg": 57444,
	"./colon-de-santa-fe.jpg": 99403,
	"./como.jpg": 1230,
	"./cruz_azul.jpg": 97508,
	"./crystal-palace.jpg": 23503,
	"./crystal_palace.jpg": 5179,
	"./danubio.jpg": 76117,
	"./defensa-y-justicia.jpg": 3515,
	"./defensor_sporting.jpg": 43565,
	"./deportivo_guadalajara.jpg": 65949,
	"./deportivo_maldonado.jpg": 61584,
	"./deportivo_toluca.jpg": 43682,
	"./dorados_de_sinaloa.jpg": 16311,
	"./estudiantes.jpg": 70584,
	"./everton.jpg": 27935,
	"./fc_juarez.jpg": 37561,
	"./fenix_uru.jpg": 59267,
	"./ferro-carril-oeste.jpg": 50305,
	"./feyenoord.jpg": 29886,
	"./fiorentina.jpg": 60849,
	"./fulham-fc.jpg": 1329,
	"./galatasaray.jpg": 50220,
	"./gimnasia-de-la-plata.jpg": 5013,
	"./godoy-cruz.jpg": 85157,
	"./hull-city.jpg": 43536,
	"./huracan.jpg": 3976,
	"./independiente-rivadavia.jpg": 78398,
	"./independiente.jpg": 32722,
	"./instituto-de-cordoba.jpg": 54026,
	"./inter.jpg": 16507,
	"./juventus.jpg": 70402,
	"./la_luz.jpg": 45096,
	"./lanus.jpg": 86263,
	"./lazio.jpg": 50701,
	"./leeds_united.jpg": 24360,
	"./leicester.jpg": 92710,
	"./leipzig.jpg": 73611,
	"./liverpool.jpg": 7974,
	"./liverpool_uru.jpg": 73728,
	"./luton-town.jpg": 68154,
	"./manchester_city.jpg": 80593,
	"./manchester_united.jpg": 48275,
	"./mazatlan_fc.jpg": 34531,
	"./milan.jpg": 54368,
	"./monaco.jpg": 23215,
	"./montevideo_city_torque.jpg": 80765,
	"./montevideo_wanderers.jpg": 45122,
	"./nacional.jpg": 63726,
	"./napoli.jpg": 6876,
	"./newcastle.jpg": 13098,
	"./newells-old-boys.jpg": 62850,
	"./norwich-city.jpg": 98044,
	"./nottingham_forest.jpg": 57655,
	"./nueva-chicago.jpg": 87313,
	"./olympique_lyon.jpg": 37644,
	"./olympique_marseille.jpg": 10427,
	"./patronato-de-parana.jpg": 52135,
	"./penarol.jpg": 25387,
	"./platense.jpg": 68773,
	"./plaza_colonia.jpg": 92821,
	"./porto.jpg": 232,
	"./progreso.jpg": 26123,
	"./psg.jpg": 79172,
	"./psv.jpg": 42576,
	"./puebla_fc.jpg": 67651,
	"./pumas_unam.jpg": 78450,
	"./queens-park-rangers.jpg": 95421,
	"./queretaro.jpg": 98705,
	"./quilmes.jpg": 10053,
	"./racing-club.jpg": 79352,
	"./racing_uru.jpg": 61863,
	"./rampla_juniors.jpg": 41130,
	"./real_betis.jpg": 56162,
	"./real_madrid.jpg": 74308,
	"./rentistas.jpg": 60608,
	"./river-plate.jpg": 75471,
	"./river_plate_uru.jpg": 29670,
	"./roma.jpg": 17873,
	"./rosario-central.jpg": 57311,
	"./san-lorenzo.jpg": 85022,
	"./san-martin-de-san-juan.jpg": 10829,
	"./santos_laguna.jpg": 85477,
	"./sarmiento-de-junin.jpg": 80210,
	"./sevilla.jpg": 19606,
	"./sheffield-united.jpg": 12278,
	"./sheffield-wednesday.jpg": 91947,
	"./southampton.jpg": 52131,
	"./sporting_cp.jpg": 28371,
	"./stoke-city.jpg": 95565,
	"./sunderland.jpg": 73537,
	"./swansea-city.jpg": 74515,
	"./talleres-de-cordoba.jpg": 52016,
	"./temperley.jpg": 1217,
	"./tigre.jpg": 25149,
	"./tottenham_hotspur.jpg": 16527,
	"./uanl_tigres.jpg": 88751,
	"./udinese.jpg": 67087,
	"./union_santa_fe.jpg": 28444,
	"./uruguay_montevideo.jpg": 2373,
	"./valencia.jpg": 26484,
	"./velez-sarsfield.jpg": 31141,
	"./villarreal.jpg": 33387,
	"./watford-fc.jpg": 65025,
	"./west-bromwich-albion.jpg": 31137,
	"./west_ham_united.jpg": 14289,
	"./wolverhampton-wanderers.jpg": 53294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96991;